import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicHelperLabelBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  // WI 31903 (helper-label piece, carried from code-hse's batch B): OnPush. Its own async writes
  // mark the view in the base; a label edit in Form Builder repaints because refreshForm() builds a
  // new config group, so the item is re-created with a new config.
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-helper-label',
  templateUrl: './dynamic-helper-label.component.html',
  standalone: false,
})
export class DynamicHelperLabelComponent extends DynamicHelperLabelBaseComponent {}
